import BillingCycle from "../Rate/BillingCycleEnum";


export function createDefaultSubscription(overrides = {}) {
  return {
    billingCycle: BillingCycle.MONTHLY,
    monthlyRate: 0,
    annualRate: 0,
    paymentStatus: "TRIAL",
    statusStartDate: new Date().toISOString().split("T")[0],
    statusEndDate: new Date().toISOString().split("T")[0],
    ...overrides,
  };
}
